const SCHEMA_ORG_BASE_URL = 'https://schema.org';

export enum SchemaOrgItemType {
    Product = `${SCHEMA_ORG_BASE_URL}/Product`,
    Brand = `${SCHEMA_ORG_BASE_URL}/Brand`,
    AggregateRating = `${SCHEMA_ORG_BASE_URL}/AggregateRating`,
    IndividualProduct = `${SCHEMA_ORG_BASE_URL}/IndividualProduct`,
    Offer = `${SCHEMA_ORG_BASE_URL}/Offer`,
    QuantitativeValue = `${SCHEMA_ORG_BASE_URL}/QuantitativeValue`,
}

export enum SchemaOrgContent {
    InStock = `${SCHEMA_ORG_BASE_URL}/InStock`,
    OutOfStock = `${SCHEMA_ORG_BASE_URL}/OutOfStock`,
    OnSitePickup = `${SCHEMA_ORG_BASE_URL}/OnSitePickup`,
}

export enum SchemaOrgItemProp {
    AggregateRating = 'aggregateRating',
    Availability = 'availability',
    AvailableDeliveryMethod = 'availableDeliveryMethod',
    Brand = 'brand',
    DeliveryLeadTime = 'deliveryLeadTime',
    Description = 'description',
    ProductId = 'productid',
    Image = 'image',
    ItemReviewed = 'itemReviewed',
    Name = 'name',
    Offers = 'offers',
    Price = 'price',
    PriceCurrency = 'priceCurrency',
    RatingValue = 'ratingValue',
    ReviewCount = 'reviewCount',
    Sku = 'sku',
    Url = 'url',
    Value = 'value',
}
